var moduleMap = {
	"./store": () => {
		return Promise.all(/* __federation_expose_store */[__webpack_require__.e(821), __webpack_require__.e(643), __webpack_require__.e(82), __webpack_require__.e(98), __webpack_require__.e(551)]).then(() => (() => ((__webpack_require__(1416)))));
	},
	"./PureTagPanel": () => {
		return Promise.all(/* __federation_expose_PureTagPanel */[__webpack_require__.e(821), __webpack_require__.e(643), __webpack_require__.e(82), __webpack_require__.e(98), __webpack_require__.e(330)]).then(() => (() => ((__webpack_require__(1938)))));
	},
	"./List": () => {
		return Promise.all(/* __federation_expose_List */[__webpack_require__.e(821), __webpack_require__.e(610), __webpack_require__.e(643), __webpack_require__.e(82), __webpack_require__.e(98), __webpack_require__.e(269), __webpack_require__.e(166), __webpack_require__.e(222), __webpack_require__.e(103)]).then(() => (() => ((__webpack_require__(5655)))));
	},
	"./CrazyList": () => {
		return Promise.all(/* __federation_expose_CrazyList */[__webpack_require__.e(821), __webpack_require__.e(610), __webpack_require__.e(643), __webpack_require__.e(82), __webpack_require__.e(98), __webpack_require__.e(269), __webpack_require__.e(166), __webpack_require__.e(222), __webpack_require__.e(911)]).then(() => (() => ((__webpack_require__(7704)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(7236)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});